import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateChild, CanActivate, CanDeactivate, GuardResult, MaybeAsync } from '@angular/router';
import { map, Observable } from 'rxjs';
import { Role } from 'src/app/models/enums/Role.enum';
import { Route } from 'src/app/models/enums/Route.enum';
import { AuthService } from 'src/app/services/auth.service';
import { SharedService } from '../../services/shared.service';
import { TermsAndConditionsService } from 'src/app/services/terms-and-conditions.service';


@Injectable({
  providedIn: 'root'
})
export class HasAssociatedStoreGuard implements CanActivate, CanActivateChild {

  constructor(
    private authService: AuthService,
    private sharedService: SharedService,
    private tecService: TermsAndConditionsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authService.user) {
      this.authService.setUser();
    }

    let store = this.authService.getStoreInLocalStorage();

    if (this.authService.user?.isUserGenerallyHQ) {
      return true;
    } else {
      if (store) {
        this.authService.setStore(store);
        return true;
      }

      if (!this.tecService.isTermsAndConditionConfirmed()) {
        return true;
      }
      this.sharedService.navigateTo_SetStorePage();
      return false;
    }
  }


  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    if (!this.authService.user) {
      this.authService.setUser();
    }

    let store = this.authService.getStoreInLocalStorage();

    if (this.authService.user?.isUserGenerallyHQ) {
      return true;
    } else {
      if (store) {
        this.authService.setStore(store);
        return true;
      }

      if (!this.tecService.isTermsAndConditionConfirmed()) {
        return true;
      }
      this.sharedService.navigateTo_SetStorePage();
      return false;
    }
  }
}
